module.exports = __webpack_public_path__ + "img/ic_search.f1a33fc3.svg";